import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../modal";
import { RillContext } from "../../rill/RillReact/share/base";

class SuggestUpgradePreview extends React.Component {
  async componentDidMount() {
    const { api } = this.props;
    const { locals } = this.context;
    const hideHeader = locals.query.hideHeader;
    if (hideHeader && api) {
      await api(`upgrade-from-ios`, {
        method: "PUT",
        body: { action: "preview" },
      });
    }
  }
  render() {
    const { t } = this.props;
    const hideHeader = this.context.locals.query.hideHeader;
    return (
      <Modal width="600px">
        <div className="head">
          <h2 className="alt">{t("suggestUpgrade.title")}</h2>
        </div>

        <div className="body">
          <p>{t("suggestUpgrade.previewDescription")}</p>
        </div>

        {!hideHeader && (
          <div className="foot">
            <a href="/dashboard/settings/subscription">
              {" "}
              <button className="button-input full">
                {t("suggestUpgrade.manageSubscription")}
              </button>{" "}
            </a>
          </div>
        )}
      </Modal>
    );
  }
}

SuggestUpgradePreview.contextType = RillContext;

export default withTranslation("coaching-portal")(SuggestUpgradePreview);
